import { SSCC, GenerateSSCC } from "../models/sscc";
import BaseService from "./_base.service";
import API from "../api";

const endpoint = "sscc/automation";

const SSCCService = {
  ...BaseService<SSCC>({ endpoint }),
  async generate(data: GenerateSSCC) {
    return await API.post(`${endpoint + "/generate"}`, data);
  },
};

export default SSCCService;
